import LinkUrl from '../data' 

export const usuarioLogado = (user) => user.email 

export const buscaUsuario = (usuario) => LinkUrl.find(u => u.nome===usuario)




